import React from 'react'
import { Screen } from '~common/screen'
import { StyledScreen } from '~common/screen'
import LineChartIcon from '~images/chats-page/line_chart.svg'
import PieChartIcon from '~images/bar_chart.svg'
import MonitorIcon from '~images/monitor.svg'
import AmoLogo from '~images/amo.svg'
import BitrixLogo from '~images/bitrix24.svg'
import BitrixMobileLogo from '~images/bitrix24_mobile.svg'
import Form from '~/components/form'
import { useIsMobile } from "~helpers/hooks/useIsMobile"
import ym from 'react-yandex-metrika'
import gtag from '~/helpers/gtag'

const ChatsMain = () => {
  const isMobile = useIsMobile()

  return (
    <Screen
      title={<span>Чаты<StyledScreen.GreenText> WhatsApp</StyledScreen.GreenText> и Telegram</span>}
      bottomLine
      size='large'
      className='chats-main'
    >
      <div className="chats-main__container">
        <p className="chats-main__description">Омниканальная платформа для вашего бизнеса с интеграцией в amoCRM и Bitrix24</p>
        <div className="chats-main__content">
          <div className="chats-main__features">
            <div className="chats-main__feature">
              <div className="chats-main__feature-icon"><LineChartIcon /></div>
              <div className="chats-main__feature-text">Больше заявок</div>
            </div>
            <div className="chats-main__feature">
              <div className="chats-main__feature-icon"><PieChartIcon /></div>
              <div className="chats-main__feature-text">Контроль над звонками и переписками</div>
            </div>
            <div className="chats-main__feature">
              <div className="chats-main__feature-icon"><MonitorIcon /></div>
              <div className="chats-main__feature-text">Работа с клиентом в режиме одного окна</div>
            </div>
          </div>
          <div className="chats-main__logos">
            <div className="chats-main__logo"><AmoLogo /></div>
            <div className="chats-main__logo">
              {
                isMobile ? <BitrixMobileLogo /> : <BitrixLogo />
              }
            </div>
          </div>
        </div>
        <Form
          formType='consultation'
          text='Протестировать 7 дней бесплатно'
          isRedirect={false}
          onSubmit={() => {
            ym('reachGoal', 'consultation_chats', 631388)
            gtag('event', 'get_consultation_chats', {'event_category': 'consultation_chats', 'event_action': 'click'})
          }}
        />
      </div>
    </Screen>
  )
}

export default ChatsMain